import axios from "axios"
import { baseURL1 } from "../utils/baseUrl"

export const updateSectionClicks = async (sectionId) => {
    await axios.get(`${baseURL1}/v1/user/update-website-clicks?section=${sectionId}`)
}